module.exports = __webpack_public_path__ + "img/website.c1829289.svg";